import { parseResponse } from "../../utils/common_lib";
import { baseApi } from "../baseApi";
export const referralsApi = baseApi.injectEndpoints({
  tagTypes: ["Referrals"],
  endpoints: (builder) => ({
    getReferrals: builder.query({
      query: (params) => {
        return {
          url: `/referrals/search_list.json`,
          method: "GET",
          params: params,
        };
      },
      transformResponse: (response, meta, arg) => {
        return parseResponse(response);
      },
    }),
  }),
});

// Export hooks for usage in functional components
export const { useGetReferralsQuery } = referralsApi;
